import configureStore from "./configureStore";

const store = configureStore();

export type RootState = ReturnType<typeof store.getState>;

export default store;